import { useApolloRequestWrapper } from '../../../api/useApolloRequestWrapper'
import { type ListRetailerLocationsQuery, useListRetailerLocationsQuery } from '../../../../api'
import { type ListRetailerLocationsResponse, type RetailerLocation } from './types'

function mapResponse(data: ListRetailerLocationsQuery) {
  if (!data?.retailerLocationSearchArray?.length) {
    return []
  }

  return (
    data.retailerLocationSearchArray
      .map(location => {
        const retailerLocation: RetailerLocation = {
          id: location.id!,
          active: location.active!,
          name: location.name!,
          locationCode: location.locationCode!,
          retailerId: location.retailerId!,
          street: location.street!,
          city: location.city!,
          state: location.state!,
          zipCode: location.zipCode!,
          pickup: location.pickup!,
          partnerAlcoholDelivery: location.partnerAlcoholDelivery!,
          hybridPickingEnabled: location.hybridPickingEnabled!,
          fulfillmentModels: location.fulfillmentModels!,
          pickingModel: location.pickingModel!,
        }
        return retailerLocation
      })
      .toSorted((a, b) => a.name.localeCompare(b.name)) ?? []
  )
}

export const useListRetailerLocations = (retailerId: string): ListRetailerLocationsResponse => {
  const query = useListRetailerLocationsQuery({
    variables: {
      retailerId,
      includeInactiveLocations: true,
    },
    fetchPolicy: 'network-only',
    refetchWritePolicy: 'overwrite',
  })

  return useApolloRequestWrapper({ query, mapResponse })
}
